<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-card>
    <v-app-bar flat dense>
      <v-toolbar-title
        ><span class="title">{{ getTitle() }}</span></v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-btn
        outlined
        small
        color="indigo"
        @click="dialog = true"
        v-if="walletsData.length < 2"
      >
        {{ $t("menu.directPayment.newKey") }}
      </v-btn>
      <v-btn icon @click="getData">
        <v-icon color="indigo">refresh</v-icon>
      </v-btn>
    </v-app-bar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <v-data-table
        :headers="headers"
        :items="walletsData"
        :loading="loading"
        hide-default-footer
        :mobile-breakpoint="0"
      >
        <template v-slot:item="props">
          <tr>
            <td class="text-xs-left">{{ props.item.title }}</td>
            <td class="text-xs-left" style="word-break: break-all;">
              {{ props.item.address }}
            </td>
            <td class="text-xs-left">
              <v-chip
                label
                small
                :color="getColorByStatus(props.item.status)"
                text-color="white"
                >{{ props.item.status | uppercase }}</v-chip
              >
            </td>
            <td class="text-xs-left">
              {{ props.item.created_at | moment("YYYY-MM-DD HH:mm:ss") }}
            </td>
            <td class="justify-center ">
              <v-menu bottom left>
                <template v-slot:activator="{ on }">
                  <v-btn icon v-on="on">
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>

                <v-list>
                  <v-list-item @click="getAddressToCheck(props.item)">
                    <v-list-item-title>{{
                      $t("menu.directPayment.checkAddress")
                    }}</v-list-item-title>
                  </v-list-item>

                  <v-list-item
                    @click="resendConfirm(props.item)"
                    v-if="props.item.status === 'unconfirmed'"
                  >
                    <v-list-item-title>{{
                      $t("menu.payoutSettings.resendConfirmation")
                    }}</v-list-item-title>
                  </v-list-item>

                  <v-divider></v-divider>

                  <v-list-item @click="removeApp(props.item)">
                    <v-list-item-title>{{
                      $t("tooltip.remove")
                    }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-divider></v-divider>
    </v-card-text>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">{{ formTitle }}</span>
        </v-card-title>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-form name="formApp" ref="formApp" :model="newApp">
                <v-text-field
                  :label="$t('menu.directPayment.keyName')"
                  v-model="newApp.title"
                  :counter="100"
                ></v-text-field>
                <v-text-field
                  :label="$t('menu.directPayment.labelXpub') + '*'"
                  v-model="newApp.address"
                  required
                ></v-text-field>
              </v-form>
            </v-flex>
          </v-layout>
          <small>{{ $t("common.noticeRequiredField") }}</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancel">{{
            $t("button.cancel")
          }}</v-btn>
          <v-btn color="blue darken-1" text @click="submitApp">{{
            $t("button.save")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogTest" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="subheading">{{
            $t("menu.directPayment.messageCheckAddress")
          }}</span>
        </v-card-title>
        <v-card-text>
          <qrcode-vue
            :value="addressTest"
            :size="qrCodeSize"
            level="H"
          ></qrcode-vue>
          <v-layout row wrap>
            <v-flex xs3> <div class="body-2">Address</div> </v-flex>
            <div class="body-1">
              <a :href="verifyAddress(addressTest, 'BTC')" target="_blank"
                >{{ addressTest }}
              </a>
            </div>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialogTest = false">{{
            $t("button.close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar
      :timeout="3000"
      bottom
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark text @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import Util from "@/util";
import QrcodeVue from "qrcode.vue";
import { verifyAddress } from "@/util/cryptoCurrencies";

export default {
  name: "TablePaymentAddress",
  props: {
    coin: String
  },
  components: {
    QrcodeVue
  },
  data(self) {
    return {
      dialog: false,
      dialogTest: false,
      qrCodeSize: 300,
      addressTest: "",
      loading: false,
      pagination: {
        page: 1,
        itemsPerPage: 10
      },
      headers: [
        {
          text: self.$t("menu.directPayment.keyName"),
          sortable: false,
          width: "100"
        },
        {
          text: self.$t("menu.directPayment.keyValue"),
          sortable: false,
          width: "400"
        },
        { text: self.$t("common.status"), sortable: false, width: "200" },
        { text: self.$t("common.createdAt"), sortable: false, width: "180" },
        { text: "", sortable: false, width: "80" }
      ],
      editedIndex: -1,
      newApp: {
        title: "",
        address: ""
      },
      defaultItem: {
        title: "",
        address: ""
      },
      snackbar: {
        show: false,
        text: "",
        color: ""
      }
    };
  },
  computed: {
    walletsData() {
      return this.$store.getters.getDirectWalletsByCoin(this.coin);
    },
    formTitle() {
      return this.editedIndex === -1
        ? this.$t("menu.directPayment.titleAddXPUB")
        : this.$t("menu.payoutSettings.editWallet");
    }
  },
  methods: {
    getTitle() {
      let title;
      switch (this.coin) {
        case "XPUB":
          title = this.$t("menu.payoutSettings.xpubAddresses");
          break;
        case "ETH":
          title = this.$t("menu.payoutSettings.wallets.ethereum");
          break;
        case "ADA":
          title = this.$t("menu.payoutSettings.wallets.cardano");
          break;
        case "XLM":
          title = this.$t("menu.payoutSettings.wallets.stellar");
          break;
        case "XRP":
          title = this.$t("menu.payoutSettings.wallets.ripple");
          break;
        default:
          title = "";
      }
      return title;
    },
    getColorByStatus(status) {
      return Util.getColorByStatus(status);
    },
    getData() {
      this.loading = true;
      this.$store
        .dispatch("fetchListPaymentWallet", {
          query: {
            page: this.pagination.page,
            per_page: this.pagination.itemsPerPage
          },
          coin: this.coin
        })
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    submitApp() {
      if (this.editedIndex > -1) {
        this.$store
          .dispatch("updatePaymentWallet", {
            data: this.newApp,
            coin: this.coin
          })
          .then(() => {
            this.getData();
            this.snackbar = {
              show: true,
              color: "green",
              text: this.$t("common.successfully")
            };
            this.close();
          })
          .catch(error => {
            this.snackbar = {
              show: true,
              color: "red",
              text: error.response.data.message
            };
          });
      } else {
        this.$store
          .dispatch("postNewPaymentWallet", {
            data: this.newApp,
            coin: this.coin
          })
          .then(() => {
            this.getData();
            this.snackbar = {
              show: true,
              color: "green",
              text: this.$t("common.successfully")
            };
            this.close();
          })
          .catch(error => {
            this.snackbar = {
              show: true,
              color: "red",
              text: error.response.data.message
            };
          });
      }
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.newApp = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    editItem(item) {
      this.editedIndex = this.walletsData.indexOf(item);
      this.newApp = Object.assign({}, item);
      this.dialog = true;
    },
    removeApp(item) {
      if (confirm(this.$t("menu.payoutSettings.confirmBeforeRemove"))) {
        this.$store
          .dispatch("deletePaymentWallet", { id: item.id, coin: this.coin })
          .then(() => {
            this.getData();
            this.snackbar = {
              show: true,
              color: "green",
              text: this.$t("common.successfully")
            };
          })
          .catch(error => {
            this.snackbar = {
              show: true,
              color: "red",
              text: error.response.data.error
            };
          });
      }
    },
    resendConfirm(item) {
      this.$store
        .dispatch("resendConfirmationPayment", { id: item.id, coin: this.coin })
        .then(() => {
          this.getData();
          this.snackbar = {
            show: true,
            color: "green",
            text: this.$t("common.successfully")
          };
        })
        .catch(error => {
          this.snackbar = {
            show: true,
            color: "red",
            text: error.response.data.error
          };
        });
    },
    getAddressToCheck(item) {
      this.$store
        .dispatch("getDirectPaymentAddressToCheck", { id: item.id })
        .then(data => {
          this.dialogTest = true;
          this.addressTest = data["address"];
        })
        .catch(error => {
          this.snackbar = {
            show: true,
            color: "red",
            text: error.response.data.error
          };
        });
    },
    cancel() {
      this.close();
    },
    verifyAddress
  },
  mounted() {
    this.getData();
  }
};
</script>
